// extracted by mini-css-extract-plugin
export default {"container":"arrow_container__2Ddqh","arrow":"arrow_arrow__eD_b2","left":"arrow_left__1ipf4","boxed":"arrow_boxed__1Mrhd","right":"arrow_right__2oZCC"};